
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import VideoHeroSection from './components/VideoHeroSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import CranesSection from './components/CranesSection';
import EquipmentSection from './components/EquipmentSection';
import SafetySection from './components/SafetySection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <VideoHeroSection />
      <StatsSection />
      <ServicesSection />
      <CranesSection />
      <EquipmentSection />
      <SafetySection />
      <TestimonialsSection />
      <CTASection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
